import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";

type PricingProps = {};

const PricingBase = ({ children }: RequireChildrenFor<PricingProps>) => {
    const { currentPrice, visibilityType } = useECommerceProduct();

    if (!currentPrice) {
        return null;
    }

    if (visibilityType === ProductVisibilityType.NotAvailable) {
        return null;
    }

    return <>{children}</>;
};

export { PricingBase };
